import ScriptLoader, { ProcessType } from "./script-loader";
import { googleTagManager, googleTagManagerPostScript } from "./external-pixels";
import aoflEventLogger from "./aofl-event-logger";

function main(): void {
  const scriptLoader = new ScriptLoader();
  scriptLoader.addScript(aoflEventLogger, ProcessType.SCRIPT);
  scriptLoader.addScript(googleTagManager, ProcessType.SCRIPT);
  scriptLoader.addScript(googleTagManagerPostScript, ProcessType.SCRIPT);
}

function ready(fn: () => void): void {
  if (document.readyState !== "loading") {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

window.onload = () => setTimeout(() => ready(main), 1000);
